import { Box } from "@mui/material";
import { HeroSectionComponent } from "../components/HeroSectionComponent";
import ServiceImage from "../assets/contactHero.webp";
import { textlanguages } from "../data/textOfThePage";
import { useLanguageContext } from "../context/languageContext";
import { capitalizeFirstLetter } from "../helpers/capitalizeFirstLetter";
import ContactSection from "../components/landing/section-contact/ContactSection";

export const ContactPage = () => {
  const { languageSelected } = useLanguageContext();
  const serviceText = textlanguages[languageSelected].header[4].service;
  return (
    <Box>
      <HeroSectionComponent
        image={ServiceImage}
        text={capitalizeFirstLetter(serviceText)}
      />
      <ContactSection />
    </Box>
  );
};
